import { ConfigModel } from '../../models/config-model';
import { InjectionToken } from '@angular/core';

export const APP_CONFIG: InjectionToken<ConfigModel> =
  new InjectionToken<ConfigModel>('Application Configuration');

export const latestActivity = [
  {
    month: 'Jan',
    id: 1,
    active: true,
  },
  {
    month: 'Feb',
    id: 2,
    active: false,
  },
  {
    month: 'Mar',
    id: 3,
    active: true,
  },
  {
    month: 'Apr',
    id: 4,
    active: true,
  },
  {
    month: 'May',
    id: 5,
    active: true,
  },
  {
    month: 'Jun',
    id: 6,
    active: true,
  },
  {
    month: 'Jul',
    id: 7,
    active: true,
  },
  {
    month: 'Aug',
    id: 8,
    active: true,
  },
  {
    month: 'Sept',
    id: 9,
    active: true,
  },
  {
    month: 'Oct',
    id: 10,
    active: true,
  },
  {
    month: 'Nov',
    id: 11,
    active: true,
  },
  {
    month: 'Dec',
    id: 12,
    active: true,
  },
];

export const timeZoneList = [
  'Pacific/Niue',
  'Pacific/Midway',
  'Pacific/Pago_Pago',
  'Pacific/Rarotonga',
  'America/Adak',
  'Pacific/Honolulu',
  'Pacific/Tahiti',
  'Pacific/Marquesas',
  'America/Anchorage',
  'America/Juneau',
  'America/Metlakatla',
  'America/Nome',
  'America/Sitka',
  'America/Yakutat',
  'Pacific/Gambier',
  'America/Los_Angeles',
  'America/Tijuana',
  'America/Vancouver',
  'Pacific/Pitcairn',
  'America/Hermosillo',
  'America/Mazatlan',
  'America/Boise',
  'America/Cambridge_Bay',
  'America/Creston',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Edmonton',
  'America/Fort_Nelson',
  'America/Inuvik',
  'America/Phoenix',
  'America/Yellowknife',
  'America/Dawson',
  'America/Whitehorse',
  'America/Bahia_Banderas',
  'America/Belize',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/Chicago',
  'America/Chihuahua',
  'America/Costa_Rica',
  'America/El_Salvador',
  'America/Guatemala',
  'America/Indiana/Knox',
  'America/Managua',
  'America/Matamoros',
  'America/Menominee',
  'America/Merida',
  'America/Mexico_City',
  'America/Monterrey',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Rankin_Inlet',
  'America/Regina',
  'America/Resolute',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Indiana/Tell_City',
  'America/Winnipeg',
  'Pacific/Easter',
  'Pacific/Galapagos',
  'America/Eirunepe',
  'America/Rio_Branco',
  'America/Bogota',
  'America/Havana',
  'America/Atikokan',
  'America/Cancun',
  'America/Cayman',
  'America/Detroit',
  'America/Grand_Turk',
  'America/Indiana/Indianapolis',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Kentucky/Louisville',
  'America/Indiana/Marengo',
  'America/Kentucky/Monticello',
  'America/Nassau',
  'America/New_York',
  'America/Panama',
  'America/Pangnirtung',
  'America/Indiana/Petersburg',
  'America/Port-au-Prince',
  'America/Toronto',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Guayaquil',
  'America/Lima',
  'America/Boa_Vista',
  'America/Campo_Grande',
  'America/Cuiaba',
  'America/Manaus',
  'America/Porto_Velho',
  'America/Anguilla',
  'America/Antigua',
  'America/Aruba',
  'America/Barbados',
  'Atlantic/Bermuda',
  'America/Blanc-Sablon',
  'America/Curacao',
  'America/Dominica',
  'America/Glace_Bay',
  'America/Goose_Bay',
  'America/Grenada',
  'America/Guadeloupe',
  'America/Halifax',
  'America/Kralendijk',
  'America/Lower_Princes',
  'America/Marigot',
  'America/Martinique',
  'America/Moncton',
  'America/Montserrat',
  'America/Port_of_Spain',
  'America/Puerto_Rico',
  'America/Santo_Domingo',
  'America/St_Barthelemy',
  'America/St_Kitts',
  'America/St_Lucia',
  'America/St_Thomas',
  'America/St_Vincent',
  'America/Thule',
  'America/Tortola',
  'America/La_Paz',
  'America/Santiago',
  'America/Guyana',
  'America/Asuncion',
  'America/Caracas',
  'America/St_Johns',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Araguaina',
  'America/Bahia',
  'America/Belem',
  'America/Fortaleza',
  'America/Maceio',
  'America/Recife',
  'America/Santarem',
  'America/Sao_Paulo',
  'Atlantic/Stanley',
  'America/Cayenne',
  'Antarctica/Palmer',
  'America/Punta_Arenas',
  'Antarctica/Rothera',
  'America/Miquelon',
  'America/Paramaribo',
  'America/Montevideo',
  'America/Nuuk',
  'America/Noronha',
  'Atlantic/South_Georgia',
  'Atlantic/Azores',
  'Atlantic/Cape_Verde',
  'America/Scoresbysund',
  'UTC',
  'Africa/Ouagadougou',
  'Africa/Abidjan',
  'America/Danmarkshavn',
  'Africa/Banjul',
  'Africa/Accra',
  'Europe/Guernsey',
  'Africa/Conakry',
  'Africa/Bissau',
  'Atlantic/Reykjavik',
  'Europe/Dublin',
  'Europe/Isle_of_Man',
  'Europe/Jersey',
  'Africa/Monrovia',
  'Africa/Bamako',
  'Africa/Nouakchott',
  'Africa/Casablanca',
  'Africa/Dakar',
  'Africa/Freetown',
  'Atlantic/St_Helena',
  'Africa/Sao_Tome',
  'Africa/Lome',
  'Antarctica/Troll',
  'Europe/London',
  'Atlantic/Canary',
  'Atlantic/Faroe',
  'Europe/Lisbon',
  'Atlantic/Madeira',
  'Africa/El_Aaiun',
  'Africa/Algiers',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Budapest',
  'Europe/Busingen',
  'Africa/Ceuta',
  'Europe/Copenhagen',
  'Europe/Gibraltar',
  'Europe/Ljubljana',
  'Arctic/Longyearbyen',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Monaco',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Rome',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Skopje',
  'Europe/Stockholm',
  'Europe/Tirane',
  'Africa/Tunis',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zurich',
  'Africa/Bangui',
  'Africa/Brazzaville',
  'Africa/Douala',
  'Africa/Kinshasa',
  'Africa/Lagos',
  'Africa/Libreville',
  'Africa/Luanda',
  'Africa/Malabo',
  'Africa/Ndjamena',
  'Africa/Niamey',
  'Africa/Porto-Novo',
  'Africa/Blantyre',
  'Africa/Bujumbura',
  'Africa/Gaborone',
  'Africa/Harare',
  'Africa/Juba',
  'Africa/Khartoum',
  'Africa/Kigali',
  'Africa/Lubumbashi',
  'Africa/Lusaka',
  'Africa/Maputo',
  'Africa/Windhoek',
  'Europe/Athens',
  'Asia/Beirut',
  'Europe/Bucharest',
  'Africa/Cairo',
  'Europe/Chisinau',
  'Asia/Gaza',
  'Asia/Hebron',
  'Europe/Helsinki',
  'Europe/Kaliningrad',
  'Europe/Kyiv',
  'Europe/Mariehamn',
  'Asia/Nicosia',
  'Europe/Riga',
  'Europe/Sofia',
  'Europe/Tallinn',
  'Africa/Tripoli',
  'Europe/Vilnius',
  'Asia/Famagusta',
  'Asia/Jerusalem',
  'Africa/Johannesburg',
  'Africa/Maseru',
  'Africa/Mbabane',
  'Asia/Aden',
  'Asia/Baghdad',
  'Asia/Bahrain',
  'Asia/Kuwait',
  'Asia/Qatar',
  'Asia/Riyadh',
  'Europe/Minsk',
  'Africa/Addis_Ababa',
  'Indian/Antananarivo',
  'Africa/Asmara',
  'Indian/Comoro',
  'Africa/Dar_es_Salaam',
  'Africa/Djibouti',
  'Africa/Kampala',
  'Indian/Mayotte',
  'Africa/Mogadishu',
  'Africa/Nairobi',
  'Asia/Amman',
  'Europe/Kirov',
  'Europe/Moscow',
  'Europe/Simferopol',
  'Antarctica/Syowa',
  'Asia/Damascus',
  'Europe/Istanbul',
  'Europe/Volgograd',
  'Asia/Tehran',
  'Asia/Yerevan',
  'Europe/Astrakhan',
  'Asia/Baku',
  'Asia/Tbilisi',
  'Asia/Dubai',
  'Asia/Muscat',
  'Indian/Mauritius',
  'Indian/Reunion',
  'Europe/Samara',
  'Europe/Saratov',
  'Indian/Mahe',
  'Europe/Ulyanovsk',
  'Asia/Kabul',
  'Indian/Kerguelen',
  'Indian/Maldives',
  'Antarctica/Mawson',
  'Asia/Karachi',
  'Asia/Dushanbe',
  'Asia/Ashgabat',
  'Asia/Samarkand',
  'Asia/Tashkent',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Atyrau',
  'Asia/Oral',
  'Asia/Qyzylorda',
  'Asia/Yekaterinburg',
  'Asia/Colombo',
  'Asia/Kolkata',
  'Asia/Kathmandu',
  'Asia/Dhaka',
  'Asia/Thimphu',
  'Asia/Almaty',
  'Asia/Qostanay',
  'Indian/Chagos',
  'Asia/Bishkek',
  'Asia/Omsk',
  'Asia/Urumqi',
  'Antarctica/Vostok',
  'Indian/Cocos',
  'Asia/Yangon',
  'Asia/Barnaul',
  'Indian/Christmas',
  'Antarctica/Davis',
  'Asia/Hovd',
  'Asia/Bangkok',
  'Asia/Ho_Chi_Minh',
  'Asia/Phnom_Penh',
  'Asia/Vientiane',
  'Asia/Krasnoyarsk',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Tomsk',
  'Asia/Jakarta',
  'Asia/Pontianak',
  'Australia/Perth',
  'Asia/Brunei',
  'Asia/Makassar',
  'Asia/Macau',
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Irkutsk',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Asia/Manila',
  'Asia/Singapore',
  'Asia/Taipei',
  'Asia/Ulaanbaatar',
  'Asia/Choibalsan',
  'Australia/Eucla',
  'Asia/Dili',
  'Asia/Jayapura',
  'Asia/Tokyo',
  'Asia/Pyongyang',
  'Asia/Seoul',
  'Pacific/Palau',
  'Asia/Yakutsk',
  'Asia/Chita',
  'Asia/Khandyga',
  'Australia/Adelaide',
  'Australia/Broken_Hill',
  'Australia/Darwin',
  'Pacific/Guam',
  'Pacific/Saipan',
  'Pacific/Chuuk',
  'Antarctica/DumontDUrville',
  'Australia/Brisbane',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Antarctica/Macquarie',
  'Australia/Melbourne',
  'Australia/Sydney',
  'Pacific/Port_Moresby',
  'Asia/Vladivostok',
  'Asia/Ust-Nera',
  'Australia/Lord_Howe',
  'Pacific/Bougainville',
  'Antarctica/Casey',
  'Pacific/Kosrae',
  'Asia/Magadan',
  'Pacific/Noumea',
  'Pacific/Norfolk',
  'Pacific/Pohnpei',
  'Asia/Sakhalin',
  'Pacific/Guadalcanal',
  'Asia/Srednekolymsk',
  'Pacific/Efate',
  'Asia/Anadyr',
  'Pacific/Fiji',
  'Pacific/Tarawa',
  'Pacific/Majuro',
  'Pacific/Kwajalein',
  'Pacific/Nauru',
  'Pacific/Auckland',
  'Antarctica/McMurdo',
  'Asia/Kamchatka',
  'Pacific/Funafuti',
  'Pacific/Wake',
  'Pacific/Wallis',
  'Pacific/Chatham',
  'Pacific/Kanton',
  'Pacific/Apia',
  'Pacific/Fakaofo',
  'Pacific/Tongatapu',
  'Pacific/Kiritimati',
];

export const dateFormat = 'dd.MM.yyyy';
export const dateFormatHour = 'dd.MM.yyyy HH:mm';

export const tableDateFormat = 'DD.MM.YYYY';
export const tableHourFormat = 'HH:mm';
export const tableDateHourFormat = 'DD.MM.YYYY HH:mm';
export const emptyDate = new Date(1, 1, 1);

export const nameMaxLength = 128;
export const nameMinLength = 3;
export const phoneNumberLength = 10;
export const internalIdLength = 25;
export const longTextMax = 256;
export const ciMinCharacters = 6;
export const ciMaxCharacters = 20;
export const maxCharactersPrice = 9;

export enum FormErrors {
  specialCharacters = 'Special characters are not accepted',
  mandatoryField = 'This field is mandatory',
  maxCharacters = 'Maximum numbers of characters is ',
  wrongEmailAddress = 'The email address is not correct',
  pleaseInsert = 'Please insert ',
  characters = ' characters',
  orMoreCharacters = ' or more characters',
  positiveValue = 'Value must be positive',
}

export const VALID_DATE_REGEX =
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
